import Icon from '@ant-design/icons';
import { useEffect, useState } from 'react';

import MindverseModal, { SizeType } from '@/components/modal';
import { useTranslation } from '@/i18n/client';
import UserProfile from '@/ui/user-profile';
import LogOut from '@/ui/user-profile/log-out';
import { EVENT } from '@/utils/event';

import styles from '../../index.less';
import { IconMap, MenuItem, MenuTNameMap } from '../constant';

interface IProps {}

const ProfileItem: React.FC<IProps> = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  const { t } = useTranslation();

  useEffect(() => {
    const handleOpen = () => {
      setShowModal(true);
    };

    addEventListener(EVENT.SHOW_MENU_PROFILE, handleOpen);

    return () => {
      removeEventListener(EVENT.SHOW_MENU_PROFILE, handleOpen);
    };
  }, []);

  return (
    <>
      <div
        className={styles.menuItem}
        onClick={() => {
          setShowModal(true);
          dispatchEvent(new Event(EVENT.FOLD_MENU));
        }}
      >
        <Icon className={styles.icon} component={IconMap[MenuItem.Profile]} />
        <span className={styles.text}>{t(MenuTNameMap[MenuItem.Profile])}</span>
      </div>
      <MindverseModal
        destroyOnClose
        footer={<LogOut />}
        maskClosable={false}
        onCancel={() => setShowModal(false)}
        open={showModal}
        size={SizeType.normal}
        title={t(MenuTNameMap[MenuItem.Profile])}
      >
        <UserProfile />
      </MindverseModal>
    </>
  );
};

export default ProfileItem;
